import React = require('react');
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isRequired } from '../../../../../../util/validators';
import { get } from 'lodash';

export const DocumentPreferences = ({ communications, documentPack }) => {

  const  post  = get(communications, 'post');

  return (
    <div className={'document-preferences-container'}>
      <div className={'pb-15'}>The documents can be accessed immediately online for your convenience or sent by post (please allow 5-7 working days). Please select your preference</div>
      <div className="document-preferences-selection-container">
        <div className={!post ? 'box selected-trip-type' : 'box'}>
          <Field
            name="communications.post"
            type="radio"
            value={false}
            complexValue={true}
            component={FieldFormControl}
            validate={[isRequired]}
          >
            <div className={`trip-type-btn`}>
              <div className={'trip-type-selection-container'}>
                <div className={'title blue'}>{'Online'}</div>
              </div>
            </div>
          </Field>
        </div>
      </div>
      <div className="document-preferences-selection-container">
        <div className={post ? 'box selected-trip-type' : 'box'}>
          <Field
            name="communications.post"
            type="radio"
            value={true}
            complexValue={true}
            component={FieldFormControl}
            validate={[isRequired]}
          >
            <div className={`trip-type-btn`}>
              <div className={'trip-type-selection-container'}>
                <div className={'title blue'}>{'Post'}</div>
              </div>
            </div>
          </Field>
        </div>
      </div>
      {post && (
        <>
          <div style={{ margin: '10px 0 10px 0' }}>Please note postal documents may take between 5 and 7 working days to arrive, which may be later than your trip start day.</div>
          <div style={{ margin: '10px 0 10px 0' }}>Please select which option you would prefer?</div>
          <div className="document-preferences-selection-container">
            <div className={documentPack === 'personal' ? 'box selected-trip-type' : 'box'}>
              <Field
                name="documentPack"
                type="radio"
                value={'personal'}
                complexValue={true}
                component={FieldFormControl}
                validate={[isRequired]}
              >
                <div className={`trip-type-btn`}>
                  <div className={'trip-type-selection-container'}>
                    <div className={'title'}>{'I’d like to receive all of my personalised documents in the post but I am happy to access the non personalised online.'}</div>
                  </div>
                </div>
              </Field>
            </div>
          </div>
          <div className="document-preferences-selection-container">
            <div className={documentPack === 'full' ? 'box selected-trip-type' : 'box'}>
              <Field
                name="documentPack"
                type="radio"
                value={'full'}
                complexValue={true}
                component={FieldFormControl}
                validate={[isRequired]}
              >
                <div className={`trip-type-btn`}>
                  <div className={'trip-type-selection-container'}>
                    <div className={'title'}>{'I’d like to receive all documents in the post.'}</div>
                  </div>
                </div>
              </Field>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
